<div class="wm-l-account-activating">
  <div class="wm-l-account-activating-spinner">
    <p-progressSpinner></p-progressSpinner>
  </div>
  <div >...your account is being activated...</div>

  @if (takingLong && !error) {
    <div class="wm-l-account-activating-bad-message" >
      Your Browser has not yet received a success confirmation, the operation is taking longer than expected.<br>
      Leaving this page is not a problem, webmate will keep working on activating your account while you are away.<br>
      If you cannot sign in with your account in a few minutes, please contact us via <a class="wm-l-topbar-helplink" href="mailto:support@testfabrik.com" target="_blank">support&#64;testfabrik.com</a> or at <a class="wm-l-topbar-helplink" href="https://support.testfabrik.com" target="_blank">support.testfabrik.com</a>.
    </div>
  }

  @if (error) {
    <div class="wm-l-account-activating-bad-message" >
      {{error | errorMsg | async}}
    </div>
  }
</div>
